import { Injectable } from "@angular/core";
import {
  ActivatedRoute,
  NavigationStart,
  Router,
  RouterEvent,
} from "@angular/router";
import {filter} from "rxjs/operators";
import {NavigationService} from "@app/services/navigation.service";
import {NavigationTemplate} from "@app/Classes/NavigationTemplate";

@Injectable()
export class RoleService {
  private urlDestination: string[] = [];
  private navTemplate: NavigationTemplate[];
  constructor(public router: Router, public activatedRoute: ActivatedRoute, private _navService: NavigationService) {
    router.events
      .pipe(filter((event: RouterEvent) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart)=> {
        if(this._navService.getPreviousUrl() != "login"){
          this.urlDestination = event.url.split("/").map(s => s.toLowerCase());
          return;
        }
        this.urlDestination = ["home"];
      });
    this.navTemplate = this._navService.getNavigationTemplate();
  }

  public isAuthorized(): boolean{
    if(this.urlDestination.includes("home"))
      return true;
    this.navTemplate.forEach((template:NavigationTemplate) => {
      if(this.urlDestination.includes(template.routerLinkName.toLowerCase())){
        return true;
      }
    })
    return false;
  }
}
